/* import __COLOCATED_TEMPLATE__ from './company-billing-payment-settings.hbs'; */
import Component from '@glimmer/component';

const PERCENT_STEP = 0.01;

class AdminCompanyBillingPaymentSettings extends Component {
  get percentStep() {
    return PERCENT_STEP;
  }

  get billingDefaults() {
    const { companyBillingDefaults, companyTierVersion, companyTier } = this.args;
    return companyBillingDefaults[companyTierVersion][companyTier];
  }

  get finderFeeValue() {
    return this.args.currentValues.finderFee ?? this.billingDefaults.finderFee * 100;
  }

  get inviteeFeeValue() {
    return this.args.currentValues.inviteeFee ?? this.billingDefaults.inviteeFee * 100;
  }

  get expenseFeeValue() {
    return this.args.currentValues.expenseFee ?? this.billingDefaults.expenseFee * 100;
  }

  get advanceFeeValue() {
    return this.args.currentValues.advanceFee ?? this.billingDefaults.advanceFee * 100;
  }

  get selectBaseFeeValue() {
    return this.args.currentValues.selectBaseFee ?? this.billingDefaults.selectBaseFee * 100;
  }

  get selectFeeValue() {
    return this.args.currentValues.selectFee ?? this.billingDefaults.selectFee * 100;
  }
}

export default AdminCompanyBillingPaymentSettings;
